import React from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import "animate.css";
import Home from "./Home";
import Ban from "./Ban";
import Main from "./Main";
import Rules from "./components/Rules";
import htgt from "./blog/howtogrowtree";

// https://getloaf.io/
// https://lottiefiles.com
// import ReCAPTCHA from "react-google-recaptcha";
// import { abbreviateNumber } from "js-abbreviation-number";
// const shortNumber = require('short-number');
// const NumAbbr = require('number-abbreviate')

// const numAbbr = new NumAbbr()

function App() {
  // const [name , setName] = useState();
  // const [age , setAge] = useState();

  return (
    <div className="container-fluid">
      <Router>
        <Route path="/" exact component={Main} />
        <Route path="/rule" exact component={Rules} />
        <Route path="/app" exact component={Home} />
        <Route path="/ban" exact component={Ban} />
        <Route path="/blog/how-to-grow-a-tree" exact component={htgt} />
      </Router>
    </div>
  );
}

export default App;
